import { useState } from "react";
import { subscriptionService, taskService } from "@miplatform/api";
import {
  ASSIGNMENT_TEMPLATE_TYPES,
  HTTP_STATUSES,
} from "@miplatform/constants";
import { useComponentState, useRouter } from "@miplatform/hooks";

export const useManageOrderTemplateViewModel = () => {
  const [isAddModalVisible, setIsAddModalVisible] = useState(false);
  const [isDeleteModalVisible, setIsDeleteModalVisible] = useState(false);
  const [selectedOrderTemplate, setSelectedOrderTemplate] = useState({});
  const [orderTemplates, setOrderTemplates] = useState([]);
  const [trades, setTrades] = useState([]);

  const stateManager = useComponentState();

  const { navigate } = useRouter();

  const loadOrderTemplates = () => {
    stateManager.run(async () => {
      const response = await taskService.orderTemplates.getAll({
        sort: "name asc",
      });

      if (response.status === HTTP_STATUSES.OK) {
        setOrderTemplates(
          response.data.map((orderType, index) => ({ ...orderType, index }))
        );
      }
    });
  };

  const toggleAddModal = () => {
    setIsAddModalVisible((prev) => !prev);
  };

  const handleAddOrderTemplate = (data) => {
    stateManager.run(async () => {
      const { name } = data;
      const { status, data: { id } = {} } =
        await taskService.orderTemplates.create({
          data: { ...data, type: ASSIGNMENT_TEMPLATE_TYPES.INSTALL },
          toastMessageConfig: {
            success: {
              text: `${name} was created.`,
            },
          },
        });

      if (status === HTTP_STATUSES.OK) {
        toggleAddModal();
        navigate(`/settings/order-management/order-types/${id}/details`);
      }
    });
  };

  const closeDeleteModal = () => {
    setIsDeleteModalVisible(false);
  };

  const openDeleteModal = (orderType) => () => {
    setIsDeleteModalVisible(true);
    setSelectedOrderTemplate(orderType);
  };

  const onDelete = () => {
    stateManager.run(async () => {
      const { id, name, modifiedOn } = selectedOrderTemplate;
      const { status } = await taskService.orderTemplates.delete({
        id,
        modifiedOn,
        toastMessageConfig: {
          success: {
            text: `${name} was deleted.`,
          },
        },
      });

      if (status === HTTP_STATUSES.OK) {
        loadOrderTemplates();
        closeDeleteModal();
      }
    });
  };
  const getTrades = () => {
    stateManager.run(async () => {
      const response = await subscriptionService.trades.getAll();
      if (response.status === HTTP_STATUSES.OK) {
        const updatedTrades = response.data.map(({ name, id }) => ({
          label: name,
          value: id,
        }));

        setTrades(updatedTrades);
      }
    });
  };

  return {
    orderTemplates,
    trades,
    isAddModalVisible,
    isLoading: stateManager.isBusy(),
    isDeleteModalVisible,
    selectedOrderTemplate,
    loadOrderTemplates,
    handleAddOrderTemplate,
    toggleAddModal,
    openDeleteModal,
    onDelete,
    closeDeleteModal,
    getTrades,
  };
};
